import { render, staticRenderFns } from "./viewStudentSubjectDiary.vue?vue&type=template&id=b6259d7a"
import script from "./viewStudentSubjectDiary.vue?vue&type=script&lang=js"
export * from "./viewStudentSubjectDiary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports